import { isPlatformGamePath } from "../../shared/routing/game-path-mode";
import type { GameApiMode } from "../../shared/services/game-api";

function currentPathname(): string {
  return typeof window === "undefined" ? "" : window.location.pathname;
}

export function isFishShopPath(pathname = currentPathname()): boolean {
  return isPlatformGamePath("fish-shop", pathname);
}

export function resolveFishShopGameApiMode(
  pathname = currentPathname(),
): GameApiMode {
  return isFishShopPath(pathname) ? "game-platform" : "legacy";
}
